// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3EXWw","info":"UpdateTermsInfo_info__1jF2Z"};